import { PlanModelInfo, planTypes } from '@/common/constants';
import { planUnitMap } from '@/common/product-unit';
import { defaultMapper } from '@/common/service/default-mapper';
import { dependBasePlanTypeList } from "./utils"
import { $config } from '@/global-install';

const videoManagementCategory = {
  video_management: {
    typeNameKey: 'billing.video_management.title',
    planNameKey: 'billing.video_management.title',
  },
};



export default (planMapJSON = {}) => {
  if (!$config('enableOnlineVideoManagement') && !window.$context.is.edit && !window.$context.is.persistCart) {
    return [];
  }
  const billingCycleDependBasePlanTypeList = dependBasePlanTypeList;
  const categoryValue = planMapJSON[planTypes.VIDEO_MANAGEMENT] || {};
  const result = Object.keys(videoManagementCategory).reduce((pre, key) => {
    return [
      ...defaultMapper(planMapJSON[key], planTypes.VIDEO_MANAGEMENT).map((item) => ({
        ...item,
        ...videoManagementCategory[key],
        billingCycleDependBasePlanTypeList,
        dependBasePlanTypeList,
        unit: planUnitMap.license,
        overage_amount: categoryValue.overage_amount,
        include_unit: categoryValue.include_unit,
        planModel: PlanModelInfo.license
      })),
      ...pre,
    ];
  }, []);
  return result;
};
